import API from "lib/api"
import { GetStaticPaths, GetStaticProps, NextPage } from "next"
import { ProductHighlight, ProductPageProps } from "types"
import ProductPage from "../../partials/product-page"
import { getFabricConfig } from "../../partials/product-page/description-fabrics"

const FabricPage: NextPage<ProductPageProps> = ({
  product,
  recommendations,
  categories,
}) => {
  const highlights: ProductHighlight[] = [
    {
      type: "rollLength",
      content: `${product.roll_length}m`,
    },
  ]

  if (product.width) {
    const width = Number.isNaN(Number.parseInt(product.width, 10))
      ? product.width
      : Number.parseInt(product.width, 10)

    if (width !== 0) {
      highlights.push({
        type: "rollWidth",
        content: String(width),
      })
    }
  }

  const fabricConfig = getFabricConfig(product)

  if (fabricConfig) {
    highlights.push({
      type: "minCutLength",
      content: `${fabricConfig.minCutLength}m`,
    })
  }

  return (
    <ProductPage
      product={product}
      highlights={highlights}
      recommendations={recommendations}
      categories={categories}
    />
  )
}

export const getStaticPaths: GetStaticPaths = async () => {
  const slugs = await API.services.index({
    type: "product",
    main_category_id: 1,
  })
  return {
    paths: slugs.map((slug: string) => ({
      params: {
        slug,
      },
    })),
    fallback: "blocking",
  }
}

export const getStaticProps: GetStaticProps = async ({ params }) => {
  try {
    const [product, recommendations, categories] = await Promise.all([
      API.services.products.single(String(params?.slug)),
      API.services.products.recommendations(String(params?.slug)),
      API.services.categories.single("fabric"),
    ])

    return {
      props: {
        product,
        recommendations,
        categories,
      },
      revalidate: 24 * 60 * 60,
    }
  } catch (error: any) {
    if (error.status === 404) {
      return {
        notFound: true,
        revalidate: 24 * 60 * 60,
      }
    }
    throw error
  }
}

export default FabricPage
